import { initialise } from ".";
import { reinitialise as reinitialiseSavedLists } from "../savedLists/reinitialise";

export const reinitialise = () => reinitialiseSavedLists(initialise);
